
import { map as map_2, defaultArg, value as value_4 } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { newBuildPopup, newButtonFoot, preventDefault, getInt2, closablePopup, choicePopup, openInBrowser, Constants_infoSignUnicode, dynamicClosablePopup, buildPopup } from "../DrawBlock/PopupHelpers.js";
import { Option, progress } from "../fable_modules/Fulma.3.0.0/Elements/Progress.fs.js";
import { Size_ISize, Common_GenericOption, TextWeight_Option, Modifier_IModifier, TextSize_Option, Screen, Text_span, Color_IColor } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { item as item_2, append as append_1, contains as contains_1, unzip, filter, sortBy, cons, collect, truncate, isEmpty, map, mapIndexed, concat as concat_1, singleton, empty, ofArray } from "../fable_modules/fable-library-js.5.13.0/List.js";
import * as react from "react";
import { WaveSimState, lastClock_, fontWeight_, fontSize_, wSConfigDialog_, wSConfig_, Msg } from "../Model/ModelType.js";
import { concat, interpolate } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { item as item_1, right, left, Level_Option, level } from "../fable_modules/Fulma.3.0.0/Layouts/Level.fs.js";
import { Option as Option_1, button } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { DOMAttr, HTMLAttr, CSSProp } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { render } from "../Common/Markdown.js";
import { Memories_help, Memories_title, WaveHelp_noHelpFor, WaveHelp_miscellaneous, WaveHelp_instructions, WaveHelp_selection, WaveHelp_viewingWaveforms, WaveHelp_gettingStarted, Info_bugReport, Info_tips, Info_gettingStarted, Info_about } from "../Common/AppMessages.js";
import { VersionString } from "../Interface/Version.js";
import { render as render_1 } from "../Common/KeyCaps.js";
import { shortcuts, shownChordsFor, chordsFor, chordShortParts } from "../Common/KeyTypes.js";
import { List_groupBy } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { getIntEventValue, debugLevel } from "../Interface/JSHelpers.js";
import { curry3, uncurry2, stringHash, compare, curry2, int32ToString, comparePrimitives, safeHash, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { table as table_1 } from "../fable_modules/Fulma.3.0.0/Elements/Table.fs.js";
import { allPairs, map as map_1, tryFind, empty as empty_1, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { Tab_Option, tab as tab_1, Option as Option_2, tabs } from "../fable_modules/Fulma.3.0.0/Components/Tabs.fs.js";
import { panel } from "./ExceptionReport.js";
import { Record } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { BoundingBox_$reflection } from "../Common/CommonTypes.js";
import { record_type, class_type, list_type, string_type, int32_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { DrawModelType_SheetT_Msg, DrawModelType_SheetT_ArrayDirection } from "../Model/DrawModelType.js";
import { arrayDirectionFor, arrayBox, arrayIsAgainstShape, maxArrayCopies, copiedFragmentBox } from "../DrawBlock/Sheet.js";
import { copiedSymbolsInPasteOrder } from "../DrawBlock/BlockHelpers.js";
import { contains, ofList } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { MapModule_ValuesL } from "../Common/EEExtensions.js";
import { fromZero, fromInt32, toInt32 } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { input } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { Option as Option_3, IInputType } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { min, max } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { Optic_Set, Optic_Set_op_HatEquals_Z147477F8, Optic_Map, Optic_Map_op_HatPercent_Z1462312A, Optic_Get, Optic_Get_op_HatDot_Z146BA564, Optics_Option_withDefault_, Compose_Lens, Compose_Lens_op_GreaterMinusGreater_Z15C92E89 } from "../Common/Optics.js";
import { Constants_wsButtonHeight, Constants_wsButtonFontSize, Constants_wsButtonWidth, Constants_maxWarnSimulationSize, Constants_minScrollingWindow, Constants_maxSimulationSize, waveSimStepCost, getWSModel, waveSimModel_ } from "./ModelHelpers.js";
import { SimulationBudget_formatBytes, StepCost__get_TotalBytes } from "../Simulator/SimTypes.js";
import { maxLastClockFor } from "../Simulator/FastSim/FastCreate.js";
import { warn } from "../Shared/Log.js";

/**
 * A popup displaying a progress bar
 */
export function progressPopup(legend, model, dispatch) {
    const pp = value_4(model.PopupDialogData.Progress);
    return buildPopup(pp.Title, (_arg, _arg_1) => {
        const children = [legend(model, pp), progress(ofArray([new Option(/* Value */ 3, [pp.Value]), new Option(/* Max */ 4, [pp.Max]), new Option(/* Color */ 1, [Color_IColor.IsPrimary])]), empty())];
        return react.createElement("div", {}, ...children);
    }, (_arg_2, _arg_3) => react.createElement("div", {}), (dispatch_1, _arg_4) => dispatch_1(new Msg(/* SetPopupProgress */ 70, [undefined])), empty(), dispatch, model);
}

/**
 * A legend with speed info for the progress bar popup
 */
export function simulationLegend(model, pp) {
    const matchValue = model.CurrentStepSimulationStep;
    let matchResult, simData;
    if (matchValue != null) {
        const copyOfStruct = matchValue;
        if (copyOfStruct.tag === 0) {
            matchResult = 0;
            simData = copyOfStruct.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return `simulation speed: ${interpolate("%6.0f%P()", [pp.Speed])} component-clocks / ms`;
        default:
            return react.createElement("div", {});
    }
}

/**
 * Popup to implement spinner for long operations
 */
export function viewSpinnerPopup(spinPayload, model, dispatch) {
    return buildPopup(spinPayload.Name, (dispatch_1, model_1) => progress(ofArray([new Option(/* Color */ 1, [Color_IColor.IsSuccess]), new Option(/* Value */ 3, [spinPayload.Total - spinPayload.ToDo]), new Option(/* Max */ 4, [spinPayload.Total])]), singleton(`${spinPayload.Total - spinPayload.ToDo}`)), (dispatch_2, model_2) => level(singleton(new Level_Option(/* Props */ 0, [singleton(["style", {
        width: "100%",
    }])])), ofArray([left(empty(), empty()), right(empty(), singleton(item_1(empty(), singleton(button(ofArray([new Option_1(/* Color */ 0, [Color_IColor.IsLight]), new Option_1(/* OnClick */ 18, [(_arg) => {
        dispatch_2(Msg.CancelWaveSimulation);
    }])]), singleton("Cancel"))))))])), (dispatch_3, _arg_1) => {
        dispatch_3(Msg.CancelWaveSimulation);
    }, empty(), dispatch, model);
}

/**
 * helper to make heading text
 */
export function makeH(h) {
    return Text_span(singleton(new Common_GenericOption(/* Modifiers */ 2, [ofArray([new Modifier_IModifier(/* TextSize */ 3, [Screen.Desktop, TextSize_Option.Is6]), new Modifier_IModifier(/* TextWeight */ 2, [TextWeight_Option.Bold])])])), ofArray([h, react.createElement("br", {})]));
}

export function styledSpan(styles, txt) {
    const props = [["style", keyValueList(styles, 1)]];
    return react.createElement("span", keyValueList(props, 1), txt);
}

export function bSpan(txt) {
    return styledSpan(singleton(new CSSProp(/* FontWeight */ 165, ["bold"])), txt);
}

export function iSpan(txt) {
    return styledSpan(singleton(new CSSProp(/* FontStyle */ 156, ["italic"])), txt);
}

export function tSpan(txt) {
    return react.createElement("span", {}, txt);
}

/**
 * top-level tabbed info popup
 */
export function makeInfoPopupButton(title, info, dispatch) {
    return button(ofArray([new Option_1(/* OnClick */ 18, [(_arg_2) => {
        dynamicClosablePopup(title, (_arg_1) => info, (_arg) => react.createElement("div", {}), singleton(new CSSProp(/* Width */ 395, [1000])), dispatch);
    }]), new Option_1(/* Size */ 1, [Size_ISize.IsSmall]), Option_1.IsRounded, new Option_1(/* Color */ 0, [Color_IColor.IsInfo]), new Option_1(/* Props */ 17, [singleton(["style", {
        height: "32px",
        fontSize: "24px",
        marginLeft: "10px",
        marginRight: "10px",
        marginTop: "3px",
        marginBottom: "0px",
        padding: "5px",
        paddingTop: "5px",
        paddingBottom: "8px",
    }])])]), singleton(Constants_infoSignUnicode));
}

const docsSite = "https://tomcl.github.io/issie";

/**
 * What a link in a help message does when clicked.
 * 
 * Everything opens in the user's own browser: in Electron an ordinary link would navigate the
 * application window away from Issie, and there is no way back. A message writes a documentation
 * page as a bare file name, which is expanded here, so the messages carry no host name to go
 * stale if the site moves.
 */
export function helpLink(url) {
    openInBrowser(url.startsWith("http") ? url : concat(docsSite, "/", url), undefined);
}

/**
 * A help message, rendered. The one entry point from AppMessages to the screen.
 */
export function helpText(markdown) {
    return render((url) => {
        helpLink(url);
    }, markdown);
}

export function viewInfoPopupAtTab(startTab, dispatch) {
    let props_48, props_50, children_46, s_17;
    const about = helpText(Info_about(VersionString));
    let gettingStarted;
    const children_2 = [helpText(Info_gettingStarted), react.createElement("button", {
        onClick: (_arg) => {
            openInBrowser("https://github.com/tomcl/ISSIE", _arg);
        },
    }, "Issie on GitHub"), react.createElement("br", {}), react.createElement("br", {})];
    gettingStarted = react.createElement("div", {}, ...children_2);
    const tips = helpText(Info_tips);
    let keys_1;
    const actionCell = (action) => {
        const props_10 = [new HTMLAttr(/* Scope */ 139, ["Row"]), ["style", {
            fontWeight: "normal",
        }]];
        return react.createElement("th", keyValueList(props_10, 1), action);
    };
    let keyTable;
    let keyRows;
    const keysFor = (isMac, s_2) => {
        const caps = (chords) => {
            const _arg_1 = concat_1(mapIndexed((i, keys) => {
                if (i === 0) {
                    return singleton(keys);
                }
                else {
                    return ofArray([" / ", keys]);
                }
            }, map((arg) => render_1(chordShortParts(isMac, arg)), chords)));
            if (isEmpty(_arg_1)) {
                return render_1(empty());
            }
            else {
                return react.createElement("span", {}, ..._arg_1);
            }
        };
        const matchValue = s_2.Trigger;
        switch (matchValue.tag) {
            case 0:
                return caps(truncate(1, chordsFor(isMac, s_2)));
            case 2:
                return caps(shownChordsFor(isMac, s_2));
            default:
                return isMac ? matchValue.fields[1] : matchValue.fields[0];
        }
    };
    keyRows = collect((tupledArg) => {
        let children_18, props_20, children_16, c;
        return cons((children_18 = [(props_20 = [new HTMLAttr(/* Scope */ 139, ["Col"]), new HTMLAttr(/* ColSpan */ 67, [3]), ["style", {
            paddingTop: "1.4em",
            fontSize: "1.05em",
        }]], (children_16 = [(c = tupledArg[0], (c.tag === 1) ? "Editing the schematic" : ((c.tag === 2) ? "View" : ((c.tag === 3) ? "Waveform simulator" : ((c.tag === 4) ? "Typing in a box" : ((c.tag === 5) ? "Mouse and gestures" : ((c.tag === 6) ? "Development" : "Project and sheets"))))))], react.createElement("th", keyValueList(props_20, 1), ...children_16)))], react.createElement("tr", {}, ...children_18)), map((s_8) => {
            const windowsKeys = keysFor(false, s_8);
            const macosKeys = keysFor(true, s_8);
            const children_12 = [actionCell(s_8.Doc), react.createElement("td", {}, windowsKeys), react.createElement("td", {}, macosKeys)];
            return react.createElement("tr", {}, ...children_12);
        }, tupledArg[1]));
    }, sortBy((arg_1) => {
        const c_1 = arg_1[0];
        switch (c_1.tag) {
            case 1:
                return 1;
            case 2:
                return 2;
            case 3:
                return 3;
            case 4:
                return 4;
            case 5:
                return 5;
            case 6:
                return 6;
            default:
                return 0;
        }
    }, List_groupBy((s_6) => s_6.Category, filter((s_5) => {
        if (s_5.Doc !== "") {
            return !(s_5.DevOnly && (debugLevel() === 0));
        }
        else {
            return false;
        }
    }, shortcuts), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }));
    let head;
    const l = map((s_9) => react.createElement("th", {
        scope: "Col",
    }, s_9), ofArray(["Action", "Windows/Linux", "macOS"]));
    head = singleton(react.createElement("tr", {}, ...l));
    keyTable = table_1(empty(), ofArray([react.createElement("thead", {}, ...head), react.createElement("tbody", {}, ...keyRows)]));
    let otherInputTable;
    let head_1;
    const l_1 = map((s_14) => react.createElement("th", {
        scope: "Col",
    }, s_14), ofArray(["Action", "Mouse", "Touchpad", "Touchscreen"]));
    head_1 = singleton(react.createElement("tr", {}, ...l_1));
    const body = map((tupledArg_1) => {
        const children_34 = [actionCell(tupledArg_1[0]), react.createElement("td", {}, tupledArg_1[1]), react.createElement("td", {}, tupledArg_1[2]), react.createElement("td", {}, tupledArg_1[3])];
        return react.createElement("tr", {}, ...children_34);
    }, singleton(["Scroll", "Shift + Left click on canvas + Drag", "Two-finger scrolling", "One-finger drag"]));
    otherInputTable = table_1(empty(), ofArray([react.createElement("thead", {}, ...head_1), react.createElement("tbody", {}, ...body)]));
    const children_48 = [makeH("Mouse and Other Input Gestures:"), otherInputTable, makeH("Keyboard Shortcuts:"), (props_48 = [["style", {
        fontStyle: "Italic",
    }]], react.createElement("div", keyValueList(props_48, 1), "Note: the same actions are on the Edit and View menus and on right-click context menus.")), (props_50 = [["style", {
        fontStyle: "Italic",
    }]], (children_46 = [(s_17 = "Note: a shortcut acts on whatever has the keyboard. In a text box the editing keys edit the text; press Return to hand the keyboard back to the schematic.", s_17)], react.createElement("div", keyValueList(props_50, 1), ...children_46))), keyTable];
    keys_1 = react.createElement("div", {}, ...children_48);
    dispatch(new Msg(/* SetPopupDialogInt */ 57, [startTab]));
    dynamicClosablePopup("ISSIE: Interactive Schematic Simulator and Integrated Editor", (model_1) => {
        const tab = model_1.PopupDialogData.Int;
        const children_52 = toList(delay(() => append(singleton_1(tabs(ofArray([Option_2.IsFullWidth, Option_2.IsBoxed]), mapIndexed((i_1, name) => tab_1(singleton(new Tab_Option(/* IsActive */ 0, [equals(tab, i_1)])), singleton(react.createElement("a", {
            onClick: (_arg_2) => {
                dispatch(new Msg(/* SetPopupDialogInt */ 57, [i_1]));
            },
        }, name))), ofArray(["Getting Started", "Tips & Features", "Keyboard Shortcuts", "About Issie", "Bug Reports"])))), delay(() => {
            let children_4;
            const matchValue_1 = tab;
            let matchResult;
            if (matchValue_1 != null) {
                switch (matchValue_1) {
                    case 0: {
                        matchResult = 0;
                        break;
                    }
                    case 1: {
                        matchResult = 1;
                        break;
                    }
                    case 2: {
                        matchResult = 2;
                        break;
                    }
                    case 3: {
                        matchResult = 3;
                        break;
                    }
                    case 4: {
                        matchResult = 4;
                        break;
                    }
                    default:
                        matchResult = 5;
                }
            }
            else {
                matchResult = 5;
            }
            switch (matchResult) {
                case 0:
                    return singleton_1(gettingStarted);
                case 1:
                    return singleton_1(tips);
                case 2:
                    return singleton_1(keys_1);
                case 3:
                    return singleton_1(about);
                case 4:
                    return singleton_1((children_4 = [helpText(Info_bugReport), panel(model_1, dispatch)], react.createElement("div", {}, ...children_4)));
                default: {
                    dispatch(new Msg(/* SetPopupDialogInt */ 57, [0]));
                    return empty_1();
                }
            }
        }))));
        return react.createElement("div", {}, ...children_52);
    }, (_arg_3) => react.createElement("div", {}), singleton(new CSSProp(/* Width */ 395, [900])), dispatch);
}

/**
 * The Info window, on the tab it is most useful to open on.
 */
export function viewInfoPopup(dispatch) {
    viewInfoPopupAtTab(0, dispatch);
}

export function viewWaveInfoPopup(dispatch, feature) {
    const waveInfo = (feature === "Getting Started") ? helpText(WaveHelp_gettingStarted) : ((feature === "Viewing Waveforms") ? helpText(WaveHelp_viewingWaveforms) : ((feature === "Waveform and RAM selection") ? helpText(WaveHelp_selection) : ((feature === "Instructions") ? helpText(WaveHelp_instructions) : ((feature === "Miscellaneous") ? helpText(WaveHelp_miscellaneous) : helpText(WaveHelp_noHelpFor(feature))))));
    dynamicClosablePopup(feature, (model) => waveInfo, (_arg) => react.createElement("div", {}), singleton(new CSSProp(/* Width */ 395, [1000])), dispatch);
}

/**
 * Waveform Selection confirmation popup
 */
export function viewWaveSelectConfirmationPopup(numRequired, numWaves, action, dispatch) {
    let children_4, s_8;
    const bSpan_1 = (txt_1) => {
        const props_2 = [["style", {
            fontWeight: "bold",
        }]];
        return react.createElement("span", keyValueList(props_2, 1), txt_1);
    };
    return choicePopup("Warning", (children_4 = [`You have selected ${numWaves} waveforms. `, react.createElement("br", {}), `Consider reducing this number to less than ${numRequired}.`, react.createElement("br", {}), "Too many waveforms selected in the viewer may impact viewer reponsiveness.", react.createElement("br", {}), "Best practice is to select only the waveforms you need to view, deleting older waveforms.", react.createElement("br", {}), react.createElement("br", {}), bSpan_1("HINT. "), (s_8 = "You can view your selected waveforms using the top line controls by removing text in all filter boxes ", s_8), "and checking the ", bSpan_1("Show Only Selected "), "checkbox.", react.createElement("br", {}), "The wave selection check boxes then allow you to deselect unwanted waveforms."], react.createElement("div", {}, ...children_4)), "Select waveforms", "Change selection", action, dispatch);
}

/**
 * Waveform selection refusal: more waveforms than the viewer can show at all.
 * 
 * Unlike the warning above this offers no way through - the one button returns to the selection -
 * so it is a closablePopup with a foot of its own rather than a choicePopup. confirmationPopup is
 * the near miss: its foot adds a Cancel beside the action button, and two buttons that both mean
 * "go back" say less than one.
 */
export function viewWaveSelectRefusalPopup(numAllowed, numWaves, dispatch) {
    let children_2;
    const bSpan_1 = (txt) => {
        const props = [["style", {
            fontWeight: "bold",
        }]];
        return react.createElement("span", keyValueList(props, 1), txt);
    };
    closablePopup("Too many waveforms", (children_2 = [`You have selected ${numWaves} waveforms, which is more than the ${numAllowed} the `, "viewer can show. Deselect some before leaving this dialog.", react.createElement("br", {}), react.createElement("br", {}), bSpan_1("HINT. "), "Clear the filter boxes above and tick ", bSpan_1("Show Only Selected"), " to list what you have chosen, wherever in the design it came from. The check ", "boxes then deselect it."], react.createElement("div", {}, ...children_2)), level(singleton(new Level_Option(/* Props */ 0, [singleton(["style", {
        width: "100%",
    }])])), ofArray([left(empty(), empty()), right(empty(), singleton(item_1(empty(), singleton(button(ofArray([new Option_1(/* Color */ 0, [Color_IColor.IsPrimary]), new Option_1(/* OnClick */ 18, [(_arg) => {
        dispatch(Msg.ClosePopup);
    }])]), singleton("Back to selection"))))))])), empty(), dispatch);
}

/**
 * Everything the Paste array dialog needs before anything is typed into it: what was copied,
 * how much of it fits, and the labels involved on both sides of the paste. Fixed for as long
 * as the dialog is open, since the dialog changes nothing on the sheet.
 */
export class PasteArray_Choices extends Record {
    constructor(Box, MaxVertical, MaxHorizontal, CopiedLabels, LabelsOnSheet) {
        super();
        this.Box = Box;
        this.MaxVertical = (MaxVertical | 0);
        this.MaxHorizontal = (MaxHorizontal | 0);
        this.CopiedLabels = CopiedLabels;
        this.LabelsOnSheet = LabelsOnSheet;
    }
}

export function PasteArray_Choices_$reflection() {
    return record_type("UIPopups.PasteArray.Choices", [], PasteArray_Choices, () => [["Box", BoundingBox_$reflection()], ["MaxVertical", int32_type], ["MaxHorizontal", int32_type], ["CopiedLabels", list_type(string_type)], ["LabelsOnSheet", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])]]);
}

function PasteArray_directionOf(dialogData) {
    const matchValue = dialogData.Text;
    let matchResult;
    if (matchValue != null) {
        if (matchValue === "horizontal") {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return DrawModelType_SheetT_ArrayDirection.ArrayHorizontal;
        default:
            return DrawModelType_SheetT_ArrayDirection.ArrayVertical;
    }
}

function PasteArray_nameOf(_arg) {
    if (_arg.tag === 1) {
        return "horizontal";
    }
    else {
        return "vertical";
    }
}

function PasteArray_setDirection(dir, dispatch) {
    return dispatch(new Msg(/* SetPopupDialogText */ 52, [PasteArray_nameOf(dir)]));
}

/**
 * Everything the dialog needs to know before anything is typed into it: the copied fragment's
 * box, how many copies of it fit each way on this sheet, and the labels involved on both
 * sides of the paste. None when nothing has been copied, which is what greys the menu item.
 */
export function PasteArray_arrayChoices(model) {
    let box, fits;
    const option_1 = copiedFragmentBox(model.Sheet);
    if (option_1 != null) {
        return (box = option_1, (fits = ((dir) => (maxArrayCopies(dir, model.Sheet.CanvasSize, box) | 0)), new PasteArray_Choices(box, fits(DrawModelType_SheetT_ArrayDirection.ArrayVertical), fits(DrawModelType_SheetT_ArrayDirection.ArrayHorizontal), filter((l) => (l !== ""), map((s) => s.Component.Label, copiedSymbolsInPasteOrder(model.Sheet.Wire.Symbol))), ofList(map((s_1) => s_1.Component.Label, MapModule_ValuesL(model.Sheet.Wire.Symbol.Symbols)), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }))));
    }
    else {
        return undefined;
    }
}

function PasteArray_tooBigPopup(dispatch) {
    let children;
    closablePopup("Nothing to array", (children = ["The copied circuit is too large for two of it to fit on one sheet, either ", "above one another or side by side, so there is no array to paste.", react.createElement("br", {}), react.createElement("br", {}), "Copy a smaller part of the circuit, or paste one copy at a time."], react.createElement("div", {}, ...children)), level(singleton(new Level_Option(/* Props */ 0, [singleton(["style", {
        width: "100%",
    }])])), ofArray([left(empty(), empty()), right(empty(), singleton(item_1(empty(), singleton(button(ofArray([new Option_1(/* Color */ 0, [Color_IColor.IsPrimary]), new Option_1(/* OnClick */ 18, [(_arg) => {
        dispatch(Msg.ClosePopup);
    }])]), singleton("Close"))))))])), empty(), dispatch);
}

function PasteArray_doPaste(dir, copies, firstSuffix, dispatch) {
    dispatch(Msg.ClosePopup);
    dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* PasteArray */ 37, [dir, copies, firstSuffix])]));
}

function PasteArray_showArrayDialog(choices, dispatch) {
    const maxFor = (dir) => {
        if (dir.tag === 1) {
            return choices.MaxHorizontal | 0;
        }
        else {
            return choices.MaxVertical | 0;
        }
    };
    const entry = (dialogData) => {
        const dir_1 = PasteArray_directionOf(dialogData);
        const limit = maxFor(dir_1) | 0;
        const first = ~~toInt32(getInt2(dialogData)) | 0;
        const matchValue = dialogData.Int;
        if (limit < 2) {
            return [undefined, first, concat("Two copies side by side ", PasteArray_nameOf(dir_1), "ly do not fit on this sheet.")];
        }
        else if (matchValue != null) {
            if (matchValue < 2) {
                const n_3 = matchValue | 0;
                return [undefined, first, "An array is two copies or more."];
            }
            else if (matchValue > limit) {
                const n_4 = matchValue | 0;
                return [undefined, first, `At most ${limit} copies fit ${PasteArray_nameOf(dir_1)}ly on this sheet.`];
            }
            else if (first < 0) {
                return [undefined, first, "Suffixes start at 0 or above."];
            }
            else {
                const n_5 = matchValue | 0;
                const matchValue_1 = tryFind((label_1) => contains(label_1, choices.LabelsOnSheet), map_1((tupledArg) => (tupledArg[1] + int32ToString(tupledArg[0])), allPairs(rangeDouble(first, 1, (first + n_5) - 1), choices.CopiedLabels)));
                if (matchValue_1 == null) {
                    return [n_5, first, ""];
                }
                else {
                    return [undefined, first, concat(matchValue_1, " is already the label of a component on this sheet. Start the ") + "suffixes somewhere else, or rename that component."];
                }
            }
        }
        else {
            return [undefined, first, "Enter how many copies you want."];
        }
    };
    dynamicClosablePopup("Paste as array", (model) => {
        let props_8, children_4, props_4, props_6, children_2, props_20, children_10, children_6, children_8, props_26;
        const dialogData_1 = model.PopupDialogData;
        const dir_2 = PasteArray_directionOf(dialogData_1);
        const patternInput = entry(dialogData_1);
        const first_1 = patternInput[1] | 0;
        const count = patternInput[0];
        const dirButton = (thisDir, label_3) => button(ofArray([new Option_1(/* Color */ 0, [equals(dir_2, thisDir) ? Color_IColor.IsPrimary : Color_IColor.IsLight]), new Option_1(/* Disabled */ 16, [maxFor(thisDir) < 2]), new Option_1(/* OnClick */ 18, [(_arg) => {
            PasteArray_setDirection(thisDir, dispatch);
        }])]), singleton(label_3));
        let suffixes;
        const matchValue_2 = dialogData_1.Int;
        let matchResult, n_8;
        if (count == null) {
            if (matchValue_2 != null) {
                if (matchValue_2 >= 2) {
                    matchResult = 0;
                    n_8 = matchValue_2;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else if (count >= 2) {
            matchResult = 0;
            n_8 = count;
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                suffixes = (`Suffixes ${first_1} to ${(first_1 + n_8) - 1} will be added to component labels.`);
                break;
            }
            default:
                suffixes = "";
        }
        const children_16 = ["Copies are placed one after another with a gap of a fifth of the circuit ", "between them, and each copy\'s labels get its suffix after them: with ", "suffix 0, MUX1 becomes MUX10. Merge and split components have no label ", "and are left without one.", react.createElement("br", {}), react.createElement("br", {}), (props_8 = [["style", {
            display: "flex",
            alignItems: "center",
        }]], (children_4 = [(props_4 = [["style", {
            marginRight: "10px",
        }]], react.createElement("span", keyValueList(props_4, 1), "Array runs")), (props_6 = [["style", {
            display: "flex",
            gap: "6px",
        }]], (children_2 = [dirButton(DrawModelType_SheetT_ArrayDirection.ArrayVertical, "Vertically"), dirButton(DrawModelType_SheetT_ArrayDirection.ArrayHorizontal, "Horizontally")], react.createElement("div", keyValueList(props_6, 1), ...children_2)))], react.createElement("div", keyValueList(props_8, 1), ...children_4))), react.createElement("br", {}), (props_20 = [["style", {
            display: "flex",
            gap: "24px",
        }]], (children_10 = [(children_6 = [`Number of copies (2 to ${maxFor(dir_2)}):`, react.createElement("br", {}), input(ofArray([new Option_3(/* Type */ 1, [IInputType.Number$]), new Option_3(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e) => {
            preventDefault(e);
        }]), ["style", {
            width: "70px",
        }], new HTMLAttr(/* AutoFocus */ 55, [true])])]), new Option_3(/* DefaultValue */ 10, [int32ToString(defaultArg(dialogData_1.Int, 2))]), new Option_3(/* OnChange */ 13, [(arg_2) => {
            dispatch(new Msg(/* SetPopupDialogInt */ 57, [getIntEventValue(arg_2)]));
        }])]))], react.createElement("div", {}, ...children_6)), (children_8 = ["Suffixes start from:", react.createElement("br", {}), input(ofArray([new Option_3(/* Type */ 1, [IInputType.Number$]), new Option_3(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e_1) => {
            preventDefault(e_1);
        }]), ["style", {
            width: "70px",
        }]])]), new Option_3(/* DefaultValue */ 10, [int32ToString(first_1)]), new Option_3(/* OnChange */ 13, [(arg_6) => {
            dispatch(new Msg(/* SetPopupDialogInt2 */ 58, [fromInt32(getIntEventValue(arg_6))]));
        }])]))], react.createElement("div", {}, ...children_8))], react.createElement("div", keyValueList(props_20, 1), ...children_10))), react.createElement("br", {}), react.createElement("div", {}, suffixes), (props_26 = [["style", {
            color: "Red",
        }]], react.createElement("span", keyValueList(props_26, 1), patternInput[2]))];
        return react.createElement("div", {}, ...children_16);
    }, (model_1) => {
        let n_12;
        const dialogData_2 = model_1.PopupDialogData;
        const dir_3 = PasteArray_directionOf(dialogData_2);
        const patternInput_1 = entry(dialogData_2);
        const first_2 = patternInput_1[1] | 0;
        const err_1 = patternInput_1[2];
        const count_1 = patternInput_1[0];
        return level(singleton(new Level_Option(/* Props */ 0, [singleton(["style", {
            width: "100%",
        }])])), ofArray([left(empty(), empty()), right(empty(), ofArray([item_1(empty(), singleton(button(ofArray([new Option_1(/* Color */ 0, [Color_IColor.IsLight]), new Option_1(/* OnClick */ 18, [(_arg_2) => {
            dispatch(Msg.ClosePopup);
        }])]), singleton("Cancel")))), item_1(empty(), singleton(button(ofArray([new Option_1(/* Color */ 0, [Color_IColor.IsPrimary]), new Option_1(/* Disabled */ 16, [err_1 !== ""]), new Option_1(/* OnClick */ 18, [(_arg_1) => {
            let matchResult_1, n_10;
            if (count_1 != null) {
                if (err_1 === "") {
                    matchResult_1 = 0;
                    n_10 = count_1;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    if (arrayIsAgainstShape(dir_3, choices.Box)) {
                        PasteArray_againstShapeWarning(choices, dir_3, n_10, first_2, dispatch);
                    }
                    else {
                        PasteArray_doPaste(dir_3, n_10, first_2, dispatch);
                    }
                    break;
                }
                case 1: {
                    break;
                }
            }
        }])]), singleton((count_1 != null) ? ((err_1 === "") ? ((n_12 = (count_1 | 0), `Paste ${n_12} copies as ${PasteArray_nameOf(dir_3)} array`)) : concat("Paste as ", PasteArray_nameOf(dir_3), " array")) : concat("Paste as ", PasteArray_nameOf(dir_3), " array")))))]))]));
    }, empty(), dispatch);
}

function PasteArray_againstShapeWarning(choices, dir, copies, firstSuffix, dispatch) {
    let children;
    const box = choices.Box;
    const patternInput = (dir.tag === 1) ? ["wider than it is tall", "vertical", "vertically"] : ["taller than it is wide", "horizontal", "horizontally"];
    const arrayed = arrayBox(dir, copies, box);
    choicePopup("This array runs along the circuit\'s long side", (children = [`The copied circuit is much ${patternInput[0]} - ${interpolate("%.0f%P()", [box.W])} by ${interpolate("%.0f%P()", [box.H])} - and a `, `${PasteArray_nameOf(dir)} array stacks the copies along that same side. ${copies} of them `, `come to ${interpolate("%.0f%P()", [arrayed.W])} by ${interpolate("%.0f%P()", [arrayed.H])}, which is a long strip to place `, "and to read.", react.createElement("br", {}), react.createElement("br", {}), concat("Arraying it ", patternInput[2], " instead would keep the copies beside each other. To do "), concat("that, go back and choose the ", patternInput[1], " direction - or lay the circuit out the "), "other way round before copying it."], react.createElement("div", {}, ...children)), `Paste ${copies} copies anyway`, "Go back", (proceed, _arg) => {
        if (proceed) {
            PasteArray_doPaste(dir, copies, firstSuffix, dispatch);
        }
        else {
            PasteArray_showArrayDialog(choices, dispatch);
        }
    }, dispatch);
}

/**
 * Edit > Paste array. Sets the dialog up - which way round to offer, and how many copies -
 * and shows it.
 */
export function PasteArray_pasteArrayPopup(model, dispatch) {
    let choices, wanted, fits;
    const matchValue = PasteArray_arrayChoices(model);
    if (matchValue != null) {
        if ((choices = matchValue, max(choices.MaxVertical, choices.MaxHorizontal) < 2)) {
            const choices_1 = matchValue;
            PasteArray_tooBigPopup(dispatch);
        }
        else {
            const choices_2 = matchValue;
            PasteArray_setDirection((wanted = arrayDirectionFor(choices_2.Box), (fits = ((wanted.tag === 1) ? (choices_2.MaxHorizontal >= 2) : (choices_2.MaxVertical >= 2)), fits ? wanted : ((wanted.tag === 1) ? DrawModelType_SheetT_ArrayDirection.ArrayVertical : DrawModelType_SheetT_ArrayDirection.ArrayHorizontal))), dispatch);
            dispatch(new Msg(/* SetPopupDialogInt */ 57, [2]));
            dispatch(new Msg(/* SetPopupDialogInt2 */ 58, [fromZero()]));
            PasteArray_showArrayDialog(choices_2, dispatch);
        }
    }
}

/**
 * Memory Properties Info Button Popup
 */
export function memPropsInfoButton(dispatch) {
    return makeInfoPopupButton(Memories_title, helpText(Memories_help), dispatch);
}

/**
 * make a popup button with the given popup
 */
export function makePopupButton(title, menu, buttonLegend, dispatch) {
    return button(ofArray([new Option_1(/* OnClick */ 18, [(_arg_1) => {
        dynamicClosablePopup(title, menu, (_arg) => react.createElement("div", {}), singleton(new CSSProp(/* Width */ 395, [600])), dispatch);
    }]), new Option_1(/* Color */ 0, [Color_IColor.IsPrimary])]), singleton(buttonLegend));
}

/**
 * Display popup, if any is present.
 * A progress popup, if present, overrides any display popup.
 * A spinner popup, if present, overrides all other popups.
 * Called from the view function
 */
export function viewPopup(model, dispatch) {
    const matchValue = model.PopupDialogData.Progress;
    const matchValue_1 = model.PopupViewFunc;
    const matchValue_2 = model.SpinnerPayload;
    let matchResult, payload, amount, popup;
    if (matchValue_2 != null) {
        if (matchValue_2.UseProgressBar) {
            matchResult = 0;
            payload = matchValue_2;
        }
        else if (matchValue == null) {
            if (matchValue_1 != null) {
                matchResult = 2;
                popup = map_2(curry2, matchValue_1);
            }
            else {
                matchResult = 3;
            }
        }
        else {
            matchResult = 1;
            amount = matchValue;
        }
    }
    else if (matchValue == null) {
        if (matchValue_1 != null) {
            matchResult = 2;
            popup = map_2(curry2, matchValue_1);
        }
        else {
            matchResult = 3;
        }
    }
    else {
        matchResult = 1;
        amount = matchValue;
    }
    switch (matchResult) {
        case 0:
            return viewSpinnerPopup(payload, model, dispatch);
        case 1:
            return progressPopup(simulationLegend, model, dispatch);
        case 2:
            return popup(dispatch)(model);
        default:
            return react.createElement("div", {});
    }
}

/**
 * Create the body of a popup to configure Waveform Simulator.
 * This must include the OK button since enable for this comes from the error checkaing here.
 */
export function dialogWaveSimConfigPopup(dispatch, model) {
    let c_1, props_18, children_14, children_12, f2, s_1, f2_1, f2_2, children_10, s_5, props_22, children_16;
    const inBounds = (bMin, bMax, n) => {
        if (compare(n, bMax) <= 0) {
            return compare(n, bMin) >= 0;
        }
        else {
            return false;
        }
    };
    Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, wSConfig_)(waveSimModel_);
    let configDialog_;
    const l_4 = Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, wSConfigDialog_)(waveSimModel_);
    configDialog_ = Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, Optics_Option_withDefault_(getWSModel(model).WSConfig))(l_4);
    const initConfig = Optic_Get_op_HatDot_Z146BA564(Optic_Get.Get, configDialog_)(model);
    getWSModel(model);
    const designCost = waveSimStepCost(model);
    const arraySizeMessage = (c) => {
        if (designCost.tag === 0) {
            const cost = designCost.fields[0];
            const needed = StepCost__get_TotalBytes(cost) * c.LastClock;
            const maxAllowed = min(maxLastClockFor(cost), Constants_maxSimulationSize) | 0;
            return `Simulating ${c.LastClock} cycles of this design needs ${SimulationBudget_formatBytes(needed)} of simulation memory. The last clock cycle can be set to at most ${maxAllowed}.`;
        }
        else {
            return "Unknown: correct schematic error to get size information";
        }
    };
    let patternInput;
    const c_2 = Optic_Get_op_HatDot_Z146BA564(Optic_Get.Get, configDialog_)(model);
    patternInput = unzip(map((tupledArg_1) => [tupledArg_1[0], tupledArg_1[2]], filter((tupledArg) => tupledArg[1], ofArray([[singleton("first"), c_2.FirstClock < 0, "The first clock cycle cannot be negative"], [singleton("last"), c_2.LastClock > Constants_maxSimulationSize, `The last clock cannot be larger than ${Constants_maxSimulationSize}`], [ofArray(["first", "last"]), c_2.FirstClock > (c_2.LastClock - Constants_minScrollingWindow), `The difference between first and last clock cycles must be at least ${Constants_minScrollingWindow} cycles.`], [singleton("fontsize"), !inBounds(12, 24, c_2.FontSize), "Font size must be between 12 and 24"], [singleton("fontweight"), !inBounds(100, 900, c_2.FontWeight), "Font weight must be between 100 and 900"], [singleton("last"), (c_1 = c_2, (designCost.tag === 0) ? (c_1.LastClock > maxLastClockFor(designCost.fields[0])) : (c_1.LastClock > Constants_maxWarnSimulationSize)), concat(arraySizeMessage(c_2), " Reduce the last clock cycle, or simulate one subsheet rather than the whole design.")]]))));
    const errorKeys = patternInput[0];
    const hasError = (key_1) => contains_1(key_1, concat_1(errorKeys), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    });
    const setConfigInt = (optic_, value_2) => {
        dispatch(new Msg(/* UpdateModel */ 41, [Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, optic_)(configDialog_))((_arg_3) => (value_2 | 0))]));
    };
    const isValid = isEmpty(concat_1(errorKeys));
    const closeAction = (changeConfig, dispatch_1, model_1) => {
        let optic_3, value_3;
        const wsm = getWSModel(model_1);
        if (changeConfig) {
            const dialog = wsm.WSConfigDialog;
            if (equals(dialog, undefined)) {
                warn("no WSConfigDialog when closing the waveform configuration popup");
            }
            dispatch_1(new Msg(/* UpdateModel */ 41, [(optic_3 = Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, wSConfig_)(waveSimModel_), (value_3 = defaultArg(dialog, wsm.WSConfig), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, optic_3)(value_3)))]));
        }
        dispatch_1(Msg.ClosePopup);
        dispatch_1(new Msg(/* UpdateModel */ 41, [Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, wSConfigDialog_)(waveSimModel_))((_arg_4) => undefined)]));
    };
    const boxStyle = ["style", {
        width: Constants_wsButtonWidth,
        font: Constants_wsButtonFontSize,
        height: 24,
        margin: 10,
    }];
    const row = (items) => {
        const props_2 = [["style", {
            borderCollapse: "collapse",
            height: "60px",
            textAlign: "justify",
        }]];
        const children_2 = mapIndexed((i, item) => {
            const props = [["style", keyValueList(append_1(singleton(new CSSProp(/* Border */ 33, ["none"])), item_2(i, ofArray([ofArray([new CSSProp(/* Width */ 395, [200]), new CSSProp(/* Margin */ 218, ["50px"]), new CSSProp(/* PaddingTop */ 281, ["10px"]), new CSSProp(/* FontWeight */ 165, [600])]), ofArray([new CSSProp(/* Width */ 395, [70]), new CSSProp(/* PaddingRight */ 280, ["50px"])]), ofArray([new CSSProp(/* Width */ 395, [800]), new CSSProp(/* LineHeight */ 213, ["24px"]), new CSSProp(/* Margin */ 218, ["40px"]), new CSSProp(/* PaddingTop */ 281, ["10px"])])]))), 1)]];
            return react.createElement("td", keyValueList(props, 1), item);
        }, items);
        return react.createElement("tr", keyValueList(props_2, 1), ...children_2);
    };
    const props_24 = [["style", {}]];
    const children_18 = [(props_18 = [["style", {
        lineHeight: "40px",
        borderStyle: "none",
        borderColor: "white",
        textAlign: "left",
    }]], (children_14 = [(children_12 = [row(ofArray([react.createElement("span", keyValueList([boxStyle], 1), "Waveform font size:"), input(ofArray([new Option_3(/* Type */ 1, [IInputType.Number$]), new Option_3(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e) => {
        preventDefault(e);
    }]), boxStyle, new HTMLAttr(/* AutoFocus */ 55, [true])])]), new Option_3(/* DefaultValue */ 10, [int32ToString(initConfig.FontSize)]), new Option_3(/* Color */ 2, [hasError("fontsize") ? Color_IColor.IsDanger : Color_IColor.IsBlack]), new Option_3(/* OnChange */ 13, [(f2 = curry2(setConfigInt)(fontSize_), (arg_12) => {
        f2(getIntEventValue(arg_12));
    })])])), (s_1 = "A larger size will be easier to read but will make numeric values overflow (and be greyed out) out more easily.", s_1)])), row(ofArray([react.createElement("span", keyValueList([boxStyle], 1), "Waveform font weight:"), input(ofArray([new Option_3(/* Type */ 1, [IInputType.Number$]), new Option_3(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e_1) => {
        preventDefault(e_1);
    }]), boxStyle, new HTMLAttr(/* AutoFocus */ 55, [true])])]), new Option_3(/* DefaultValue */ 10, [int32ToString(initConfig.FontWeight)]), new Option_3(/* Color */ 2, [hasError("fontweight") ? Color_IColor.IsDanger : Color_IColor.IsBlack]), new Option_3(/* OnChange */ 13, [(f2_1 = curry2(setConfigInt)(fontWeight_), (arg_13) => {
        f2_1(getIntEventValue(arg_13));
    })])])), "Font weight of 300 = normal, 600 = bold, etc"])), row(ofArray([react.createElement("span", keyValueList([boxStyle], 1), "Max clock cycle:"), input(ofArray([new Option_3(/* Type */ 1, [IInputType.Number$]), new Option_3(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e_2) => {
        preventDefault(e_2);
    }]), boxStyle, new HTMLAttr(/* AutoFocus */ 55, [true])])]), new Option_3(/* DefaultValue */ 10, [int32ToString(initConfig.LastClock)]), new Option_3(/* Color */ 2, [hasError("last") ? Color_IColor.IsDanger : Color_IColor.IsBlack]), new Option_3(/* OnChange */ 13, [(f2_2 = curry2(setConfigInt)(lastClock_), (arg_14) => {
        f2_2(getIntEventValue(arg_14));
    })])])), (children_10 = [(s_5 = "Note that the waveform simulator will only simulate and scroll up to the current last cycle which is much smaller than this unless cursor movement or scroll forces more to be simulated.", s_5), react.createElement("br", {}), react.createElement("br", {}), arraySizeMessage(initConfig)], react.createElement("div", {}, ...children_10))]))], react.createElement("tbody", {}, ...children_12))], react.createElement("table", keyValueList(props_18, 1), ...children_14))), (props_22 = [["style", {
        color: "red",
        height: 100,
    }]], (children_16 = concat_1(map((mess) => ofArray([mess, react.createElement("br", {})]), patternInput[1])), react.createElement("div", keyValueList(props_22, 1), ...children_16))), newButtonFoot(uncurry2(curry3(closeAction)(true)), "Ok", uncurry2(curry3(closeAction)(false)), (_arg_5) => !isValid, dispatch, model)];
    return react.createElement("div", keyValueList(props_24, 1), ...children_18);
}

export function makeWSPopupButton(body, iColor, cssProps, dispatch, model) {
    return button(ofArray([new Option_1(/* OnClick */ 18, [(_arg) => {
        dispatch(new Msg(/* ShowPopup */ 49, [body]));
    }]), new Option_1(/* Color */ 0, [Color_IColor.IsPrimary]), new Option_1(/* Disabled */ 16, [equals(getWSModel(model).State, WaveSimState.Success)]), new Option_1(/* Props */ 17, [singleton(["style", keyValueList(cssProps, 1)])])]), singleton("Configure"));
}

export function makeWSConfigButton(dispatch, model) {
    const closeConfigDialog = new Msg(/* UpdateModel */ 41, [Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, wSConfigDialog_)(waveSimModel_))(undefined)]);
    return makeWSPopupButton((dispatch_2, model_1) => newBuildPopup("Advanced Configuration", dialogWaveSimConfigPopup, (_arg, _arg_1) => react.createElement("div", {}), (dispatch_1, _arg_2) => {
        dispatch_1(closeConfigDialog);
    }, ofArray([new CSSProp(/* Height */ 189, [600]), new CSSProp(/* Width */ 395, [1200])]), dispatch_2, model_1), Color_IColor.IsSuccess, ofArray([new CSSProp(/* Height */ 189, [Constants_wsButtonHeight]), new CSSProp(/* Width */ 395, [Constants_wsButtonWidth])]), dispatch, model);
}

